import React, { createContext, useContext, useState, useCallback } from "react";
import { dataService } from "../services/dataService";
import Modal from "../components/modals/Modal";
import { useOrder } from "./OrderContext";
import { useLocation } from "react-router-dom";

import { IconAlertCircle } from "@tabler/icons-react";

const OrderSaveContext = createContext();

export const OrderSaveProvider = ({ children }) => {
	const [modal, setModal] = useState({ open: false, message: "", type: "danger" });
	const [loading, setLoading] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const { order, updateOrder, replaceOrder, resetOrder } = useOrder();
	const location = useLocation();

	const closeModal = () => setModal({ open: false, message: "", type: "danger" });

	const saveOrder = useCallback(
		async (order) => {
			const calculated_path = location.pathname.startsWith("/") ? location.pathname.slice(1) : location.pathname;
			console.log("Mentés helye:", calculated_path);

			const orderWithPath = {
				...order,
				save_path_source: calculated_path,
			};

			setLoading(true);
			try {
				const response = await dataService.saveOrder(orderWithPath);
				const data = response.data;
				if (data.status === "error") {
					setModal({
						open: true,
						message: "<h4>" + data.message + '</h4> <span style="color: grey">Kérem, próbálkozzon újra!</span>' || "Hiba történt a rendelés mentésekor! Kérem, próbálja újra!",
						type: "danger"
					});
					return { success: false, error: data.message };
				}
				updateOrder({
					...order,
					...(data.data.hmeliorder !== undefined && {
						hmeliorder: {
							...order.hmeliorder,
							...data.data.hmeliorder
						}
					}),
					...(data.data.projekt !== undefined && {
						projekt: {
							...(order.projekt || {}),
							...data.data.projekt
						}
					}),
					...(data.data.venyek !== undefined && {
						venyek: data.data.venyek
					}),
				});
				setSuccessMessage("Sikeres mentés!");
				setTimeout(() => setSuccessMessage(""), 2000);
				setLoading(false);
				return { success: true, data };
			} catch (error) {
				setModal({ open: true, message: "Hiba történt a rendelés mentésekor! Kérem, próbálja meg újból!", type: "danger" });
				return { success: false, error: error.message };
			} finally {
				setLoading(false);
			}
		},
		[updateOrder, location]
	);

	return (
		<OrderSaveContext.Provider value={{ saveOrder, loading, successMessage }}>
			{children}
			<Modal
				isOpen={modal.open}
				onClose={closeModal}
				onConfirm={closeModal}
				title={modal.type === "success" ? "Siker" : "Hiba"}
				type={modal.type}
				confirmText="OK"
				showCancel={false}
				icon={<IconAlertCircle
					size={48}
					stroke={2}
					className="text-danger"
				/>}>
				<div dangerouslySetInnerHTML={{ __html: modal.message }} />
			</Modal>
		</OrderSaveContext.Provider>
	);
};

export const useOrderSave = () => useContext(OrderSaveContext);
